import axiosClient from "utils/api";
const URI = "/admin/staticPage";

export const getCms = async (payload) => {
  const URL = `${URI}/${payload?.type}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Get cms:", error);
    throw error;
  }
};

export const updateCms = async (payload) => {
  let { id, ...rest } = payload;
  const URL = `${URI}/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "put",
      data: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Update cms:", error);
    throw error;
  }
};

export const addCms = async (payload) => {
  const URL = `${URI}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred add cms:", error);
    throw error;
  }
};

export const deleteCms = async (payload) => {
  const URL = `${URI}/${payload?.id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "delete",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred delete cms:", error);
    throw error;
  }
};

